const stats = [
  { icon: "ri-percent-line", value: "10.00%", label: "Target Per Annum", sub: "Monthly distributions", color: "#C9A84C" },
  { icon: "ri-calendar-event-line", value: "5 Years", label: "Investment Term", sub: "With rollover option", color: "#C9A84C" },
  { icon: "ri-building-2-line", value: "UK", label: "Asset Location", sub: "Assisted living properties", color: "#C9A84C" },
  { icon: "ri-shield-check-line", value: "1st", label: "Legal Charge Security", sub: "Independent trustee held", color: "#C9A84C" },
];

export default function StatsSection() {
  return (
    <section
      className="py-20 relative overflow-hidden"
      style={{ background: "linear-gradient(135deg, #071A2E 0%, #0D2B4A 50%, #071A2E 100%)" }}
    >
      {/* Gold glowing orbs */}
      <div
        className="absolute top-0 left-1/4 w-96 h-96 rounded-full pointer-events-none opacity-20"
        style={{ background: "radial-gradient(circle, rgba(201,168,76,0.3) 0%, transparent 70%)", transform: "translateY(-50%)" }}
      />
      <div
        className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full pointer-events-none opacity-15"
        style={{ background: "radial-gradient(circle, rgba(201,168,76,0.25) 0%, transparent 70%)", transform: "translateY(50%)" }}
      />

      {/* Gold top line */}
      <div
        className="absolute top-0 left-0 right-0 h-[1px]"
        style={{ background: "linear-gradient(90deg, transparent, rgba(201,168,76,0.6), transparent)" }}
      />

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="text-center mb-14">
          <span className="text-[#C9A84C] text-[10px] font-bold uppercase tracking-[0.22em] block mb-3">
            Key Investment Metrics
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-white"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            The Numbers That Matter
          </h2>
          <p className="text-slate-400 text-sm mt-3 max-w-md mx-auto">
            A transparent, structured product designed to deliver consistent monthly income from UK social housing assets.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((s, i) => (
            <div
              key={i}
              className="flex flex-col items-center text-center rounded-2xl p-5 md:p-8 border border-white/8 hover:border-[#C9A84C]/30 transition-all duration-300 group relative overflow-hidden"
              style={{ background: "rgba(255,255,255,0.04)" }}
            >
              {/* Inner gold glow on hover */}
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none rounded-2xl"
                style={{ background: "radial-gradient(circle at center, rgba(201,168,76,0.06) 0%, transparent 70%)" }}
              />

              <div
                className="w-11 h-11 md:w-14 md:h-14 flex items-center justify-center rounded-xl mb-4 relative z-10"
                style={{ backgroundColor: "rgba(201,168,76,0.12)", boxShadow: "0 0 20px rgba(201,168,76,0.15)" }}
              >
                <i
                  className={`${s.icon} text-xl md:text-2xl leading-none`}
                  style={{ color: "#C9A84C" }}
                />
              </div>
              <p
                className="text-2xl md:text-4xl font-bold text-white mb-1 relative z-10"
                style={{ fontFamily: "'Playfair Display', serif", textShadow: "0 0 20px rgba(201,168,76,0.3)" }}
              >
                {s.value}
              </p>
              <p className="text-slate-300 text-[10px] md:text-xs font-semibold mb-1 relative z-10 uppercase tracking-wide">{s.label}</p>
              <p className="text-slate-500 text-[10px] md:text-xs relative z-10">{s.sub}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Gold bottom line */}
      <div
        className="absolute bottom-0 left-0 right-0 h-[1px]"
        style={{ background: "linear-gradient(90deg, transparent, rgba(201,168,76,0.4), transparent)" }}
      />
    </section>
  );
}
